import actionTypes from './actionTypes';

const initialState = {
	filters: {},
	result: [],
	compare: {
		primary: undefined,
		secondary: undefined,
	},
	selected: {},
	previousButtonLocked: false,
	nextButtonLocked: false,
	isFetching: false,
	fetchingFailed: false,
	fetchingSucceeded: false,
};

export default function productReducer(state = initialState, action) {
	switch (action.type) {
		case actionTypes.FETCH_PRODUCTS:
		case actionTypes.FETCH_PRODUCTS_BY_CATEGORY:
		case actionTypes.SEARCH_PRODUCTS:
			return {
				...state,
				result: action.data,
				filters: {
					...state.filters,
					...action.filters,
				},
			};
		case actionTypes.FETCH_PRODUCT_BY_SLUG:
		case actionTypes.GO_TO_NEXT_ITEM:
		case actionTypes.GO_TO_PREVIOUS_ITEM:
			return {
				...state,
				selected: action.data.item,
				previousButtonLocked: action.data.index === 0,
				nextButtonLocked: action.data.index === (state.result.length - 1),
			};
		case actionTypes.COMPARE_PRODUCT_PRIMARY:
			return {
				...state,
				compare: {
					...state.compare,
					primary: action.product,
				},
			};
		case actionTypes.COMPARE_PRODUCT_SECONDARY:
			return {
				...state,
				compare: {
					...state.compare,
					secondary: action.product,
				},
			};
		case actionTypes.REMOVE_COMPARE_PRODUCT_PRIMARY:
			return {
				...state,
				compare: {
					...state.compare,
					primary: state.compare.secondary || undefined,
					secondary: undefined,
				},
			};
		case actionTypes.REMOVE_COMPARE_PRODUCT_SECONDARY:
			return {
				...state,
				compare: {
					...state.compare,
					secondary: undefined,
				},
			};
		case actionTypes.FETCHING_IN_PROGRESS:
			return {
				...state,
				isFetching: true,
				fetchingFailed: false,
				fetchingSucceeded: false,
			};
		case actionTypes.FETCHING_FAILED:
			return {
				...state,
				isFetching: false,
				fetchingFailed: true,
			};
		case actionTypes.FETCHING_SUCCEEDED:
			return {
				...state,
				isFetching: false,
				fetchingSucceeded: true,
			};
		case actionTypes.CHECK_BEFORE_FETCH:
			return {
				...state,
			};
		case actionTypes.REMOVE_PRODUCT:
			return {
				...state,
				result: state.result.filter(res => res.id !== action.id),
			};
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/redux/product/productReducer.js